@if(isLoading) {
    <div style="
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100%;
        margin-top: 170px;
        margin-bottom: 100px;"
    >
        <mat-spinner></mat-spinner>
        <br />
        <span>Loading data...</span>
    </div>
} @else {
    <ng-content></ng-content>
}
